var Curriculog = Curriculog || {};

Curriculog.ApiSecretList = (function ($, _, Backbone, ApiSecretList, util, dom) {

    var ApiSecretList = Curriculog.CurriculogView.extend({
            el: '#api-key-list',
            template: 'Api/ApiKeyList.html',

            initialize: function (options) {
                this.collection = options.collection;
                this.cui_enabled = options.cui_enabled;
                this.listenTo(this.collection, 'add', this.render);
                this.listenTo(this.collection, 'remove', this.render);
                this.render();
            },

            render: function () {
                var secret_key_names = [];
                this.collection.each(function(item) {
                    secret_key_names.push(item.toJSON());
                });

                secret_key_names = _.sortBy(secret_key_names, function(item) { return item.name; });

                templateData = {keys: secret_key_names}
                var el = nunjucks.render(this.template, templateData)
                this.replaceElement(el);
                if (!this.cui_enabled) {
                  objDom.verticalStretchList();
                }
            },
    });

    return ApiSecretList;

})($, _, Backbone, Curriculog.ApiSecretList || {}, Curriculog.util, dom);
